export default __webpack_public_path__ + "static/media/img4.776ce864.webp";